<template>
  <div class="item">
    <span v-if="description"> {{ `${description} ` }}</span>
    <a
      v-if="url"
      target="_blank"
      rel="noopener noreferrer"
      :href="url"
      v-html="text"
    />
    <span
      v-else
      v-html="text"
    />
  </div>
</template>

<script lang="ts">
  import type { PropType } from 'vue';

  import type { TArticleNoteItem } from '~/types';

  export default defineNuxtComponent({
    name: 'ArticleNoteItem',

    props: {
      description: {
        type: String as PropType<TArticleNoteItem['description']>,
        default: '',
      },

      text: {
        type: String as PropType<TArticleNoteItem['text']>,
        required: true,
      },

      url: {
        type: String as PropType<TArticleNoteItem['url']>,
        default: '',
      },
    },
  });
</script>

<style lang="scss" scoped>
  $textColor: #5c5c5c;
  .item {
    padding-bottom: 8px;

    font-family: $mainFont;
    font-size: 12px;
    line-height: 18px;
    color: $textColor;
    overflow: hidden;
    text-overflow: ellipsis;

    &:nth-last-child(2) {
      padding-bottom: 12px;
      border-bottom: 1px solid $borderColor;
      @include desktop {
        border-bottom: none;
      }
    }

    &:last-child {
      padding-bottom: 0;
    }

    a {
      text-decoration: none;
      color: $textColor;
      outline: none;
      @include linkTinyStyle;
    }
  }

  .typo-info {
    display: none;
    @include desktop {
      border-top: 1px solid $borderColor;
      padding-top: 12px;
      display: block;
    }
  }
</style>
